import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  ModalBody,
  useMultiStyleConfig,
} from '@chakra-ui/react';

import { HeadingComponent } from '../Heading';

type ScrollBehaviorType = 'inside' | 'outside';
type SizeType = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full';

export type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  scrollBehavior?: ScrollBehaviorType;
  size?: SizeType;
  title?: string;
  testId?: string;
  footer?: React.ReactNode;
  children: React.ReactNode;
  closeOnOverlayClick?: boolean;
  canBeClosed?: boolean;
};

export const ModalComponent = ({
  isOpen,
  onClose,
  scrollBehavior = 'outside',
  size = 'xl',
  title,
  footer,
  children,
  testId,
  closeOnOverlayClick = true,
  canBeClosed = true,
}: ModalProps) => {
  const styles = useMultiStyleConfig('Modal', {
    variant: size,
  });
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      preserveScrollBarGap
      scrollBehavior={scrollBehavior}
      size={size}
      closeOnOverlayClick={canBeClosed && closeOnOverlayClick}
    >
      <ModalOverlay />

      <ModalContent sx={styles.content} data-testid={testId}>
        {title && (
          <ModalHeader>
            <HeadingComponent color="brand.default" variant="secondary">
              {title}
            </HeadingComponent>
          </ModalHeader>
        )}

        {canBeClosed ? <ModalCloseButton /> : null}

        <ModalBody paddingTop={title ? 2 : 4}>{children}</ModalBody>

        {footer && <ModalFooter>{footer}</ModalFooter>}
      </ModalContent>
    </Modal>
  );
};
